import { connect } from 'react-redux'

import { CreatePushNotification } from '../components/PushNotifications/CreatePushNotification'
import { createPushNotification, modalOpen } from '../modules/PushNotifications/actions'

const mapStateToProps = ({ pushNotifications, auth }) => {
    return {
        notification_loading: pushNotifications.notification_loading,
        modalClose: pushNotifications.modalClose,
        user: auth.user,
    }
}

const mapDispatchToProps = {
    createPushNotification,
    modalOpen,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreatePushNotification)
